import React from "react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { pains } from "../data/content";
export function PainPoints() {
  return <section className="w-full bg-navy px-5 py-16 sm:py-20" data-id="element-221" data-mp="26yfqvg0w17ll">
      <SectionHeading tone="dark" eyebrow="Do Any of These Sound Familiar?" title="If You Recognize Yourself Here, I Created This System for You." data-id="element-222" data-mp="26y5zpp43wueb" />
      <ol className="mx-auto mt-10 grid max-w-5xl gap-4 md:grid-cols-2" data-id="element-223" data-mp="1xwyea7movo1n">
        {pains.map((p, i) => <li key={p.title} className="flex gap-4 rounded-2xl bg-navy-800 p-5 sm:p-6" data-id="element-224" data-mp="2204kjf9sxf84" data-mpi={i}>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold font-display text-xl font-black text-navy" data-id="element-225" data-mp="1o0llrd2vrg8h">
              {i + 1}
            </span>
            <div data-id="element-226" data-mp="3idbf9tpc6nfc">
              <h3 className="font-display text-lg font-extrabold leading-snug text-white" data-id="element-227" data-mp="3iewbrov7ogfu">{p.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-white/75" data-id="element-228" data-mp="3nbcvm6vdo8n4">{p.body}</p>
            </div>
          </li>)}
      </ol>

      <div className="mx-auto mt-12 max-w-2xl rounded-3xl bg-white p-6 sm:p-10" data-id="element-229" data-mp="1yyc1pomd08r3">
        <p className="text-sm font-extrabold uppercase tracking-wider text-brand" data-id="element-230" data-mp="1tzhk2q04oq8k">And here's what I've learned.</p>
        <p className="mt-3 font-display text-2xl font-black leading-tight text-navy sm:text-3xl" data-id="element-231" data-mp="27utcuruq46mu">
          The problem isn't always a lack of technical knowledge.
        </p>
        <div className="mt-4 space-y-4 text-lg leading-relaxed text-muted" data-id="element-232" data-mp="1g22rjcekw2cd">
          <p data-id="element-233" data-mp="1b417op9bvyzu">
            Sometimes, the problem is that you have no consistent system for organizing the information, evidence, and
            decisions required to investigate a complicated electrical fault.
          </p>
          <p data-id="element-234" data-mp="1k2340ri4a3gs">You shouldn't have to rely on memory alone to reconstruct every step of a diagnostic case.</p>
          <p data-id="element-235" data-mp="30jqtyrn77xe0">
            You need a process that helps you identify what you know, what you've verified, what remains uncertain, and
            what information you need before deciding how to proceed.
          </p>
          <p className="font-semibold text-navy" data-id="element-236" data-mp="1y483ourjrdo3">That's the purpose of the BCM Diagnostic Blueprint™.</p>
        </div>
      </div>

      <div className="mt-10" data-id="element-237" data-mp="225ldffxrg10a">
        <CtaButton tone="dark" data-id="element-238" data-mp="226cw5q69e495">I Want a Structured Diagnostic System</CtaButton>
      </div>
    </section>;
}